import { ElementRef } from '@angular/core';
import { CUSTOMIZE_PAGES_FEATURE } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { FeatureNeededComponent } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.component';
import * as i0 from "@angular/core";
import * as i1 from "AccountsApp/ts/services/accounts.service";
import * as i2 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i3 from "@angular/common";
import * as i4 from "../../../../../../entitlements/static/entitlements/ts/features/feature-needed/feature-needed.component";
const _c0 = a0 => ({ active: a0 });
function RiskLookbackComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "a", 4);
    i0.ɵɵlistener("click", function RiskLookbackComponent_div_2_Template_a_click_1_listener() { const lookbackOption_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.updateLookback(lookbackOption_r2)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const lookbackOption_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0, ctx_r2.lookback === lookbackOption_r2.value));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", lookbackOption_r2.label, " ");
} }
const RISK_LOOKBACK_OPTIONS = [
    { label: '3Y', value: '3' },
    { label: '5Y', value: '5' },
    { label: '10Y', value: '10' },
    { label: '15Y', value: '15' },
    { label: 'all', value: 'all' },
];
export class RiskLookbackComponent {
    constructor(eltRef, accountsService, featureService) {
        this.eltRef = eltRef;
        this.accountsService = accountsService;
        this.featureService = featureService;
        this.riskLookbackOptions = RISK_LOOKBACK_OPTIONS;
        this.lookback = this.eltRef.nativeElement.getAttribute('lookback');
    }
    updateLookback(lookbackOption) {
        if (lookbackOption.value !== this.lookback) {
            if (!this.featureService.userHasFeatures([CUSTOMIZE_PAGES_FEATURE])) {
                this.featureNeededComponent.openModal(CUSTOMIZE_PAGES_FEATURE);
                return;
            }
            this.accountsService.putUserPreferences({ risk_lookback: lookbackOption.value }).subscribe({
                next: () => window.location.reload(),
                error: () => { },
            });
        }
    }
}
RiskLookbackComponent.ɵfac = function RiskLookbackComponent_Factory(t) { return new (t || RiskLookbackComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.AccountsService), i0.ɵɵdirectiveInject(i2.FeatureService)); };
RiskLookbackComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RiskLookbackComponent, selectors: [["ycn-risk-lookback"]], viewQuery: function RiskLookbackComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(FeatureNeededComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.featureNeededComponent = _t.first);
    } }, inputs: { lookback: "lookback" }, decls: 4, vars: 1, consts: [[1, "panel-action"], [1, "nav", "nav-tabs"], ["class", "nav-item", 4, "ngFor", "ngForOf"], [1, "nav-item"], ["href", "", 1, "nav-link", 3, "click", "ngClass"]], template: function RiskLookbackComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "ul", 1);
        i0.ɵɵtemplate(2, RiskLookbackComponent_div_2_Template, 3, 4, "div", 2);
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(3, "ycn-feature-needed");
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.riskLookbackOptions);
    } }, dependencies: [i3.NgClass, i3.NgForOf, i4.FeatureNeededComponent], encapsulation: 2 });
